import { useQuery } from "@tanstack/react-query";

import { fetchSessions } from "@/lib/api";
import type { Filters } from "@/lib/types";

interface UseSessionsOptions {
  enabled?: boolean;
  refetchIntervalInBackground?: boolean;
}

export function useSessions(filters: Filters, options?: UseSessionsOptions) {
  return useQuery({
    queryKey: ["sessions", filters],
    enabled: options?.enabled ?? true,
    refetchIntervalInBackground: options?.refetchIntervalInBackground ?? false,
    queryFn: () => fetchSessions(filters),
    refetchInterval: (query) => {
      // Poll every 3s if any session is still in-flight
      const hasPending = query.state.data?.sessions.some(
        (s) =>
          s.latestStatus === "pending" ||
          s.latestStatus === "processing" ||
          s.latestStatus === "awaiting_response",
      );
      return hasPending ? 3000 : false;
    },
  });
}
